import { render, staticRenderFns } from "./FavouriteSection.vue?vue&type=template&id=f105e97a"
import script from "./FavouriteSection.vue?vue&type=script&lang=js"
export * from "./FavouriteSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports